/**
 * Whether App() should render <MobileApp/> instead of the desktop product.
 *
 * demo-review-2026-09-09 P0: this used to also fire on UA-sniffing
 * (isMobileDevice) and installed-PWA display mode (isStandalone) — meaning
 * every phone/tablet visitor was force-routed into the mobile app with no
 * way back to desktop, and every mobile screen throws
 * (`user.getIdToken is not a function`). Until the mobile app is fixed,
 * it's reachable only by explicitly navigating to /mobile — never
 * automatically.
 */
export function shouldShowMobileApp({ pathname }) {
  return pathname.startsWith('/mobile');
}

/**
 * demo-review-2026-09-09 P2: the post-login Dashboard reads the
 * `restaurants` collection while the demo seed writes `locations` — so a
 * freshly-logged-in prospect landed on "No restaurants added yet" for a
 * tenant with 23 ingredients, 18 recipes, 16 menu items, stock and a
 * document vault. Land on the costing hero instead: cheaper than seeding a
 * `restaurants` doc, and it's the stronger first five seconds regardless.
 */
export const POST_LOGIN_ROUTE = '/cost-intel';
